
import { mapMutations, mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      cookiesPrivacy: 'cookies/cookies/cookiesPrivacy'
    })
  },
  methods: {
    ...mapMutations({
      setCookiesPrivacy: 'cookies/cookies/SET_COOKIES_PRIVACY'
    }),
    changeStateModalCookie() {
      document.cookie = "stateModal=1; max-age=259200";
      this.setCookiesPrivacy(false)
    }
  },
  beforeMount() {
    if (!document.cookie.match(/stateModal=(.+?)(;|$)/)) {
      this.setCookiesPrivacy(true)
    }
  },
}
